import { data } from '../../svg/Apartment/data';
import { makeIcon } from '../makeIcon';

export const Apartment = makeIcon(data, 'apartment', 'Apartment');

export default Apartment;
